import { useItem } from '@/composables/item'
import { syncService } from '@/services/api'
import { defineStore, acceptHMRUpdate } from 'pinia'

export const useSyncStore = defineStore('sync', () => {
	const { items, show, getItem } = useItem<Api.Sync>(
		syncService,
		'syncs',
		'Sync'
	)
	return {
		items,
		show,
		getItem,
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useSyncStore, import.meta.hot))
}
